function getUTMParameters() {
    var params = {};
    var queryString = window.location.search.substring(1);
    var regex = /([^&=]+)=([^&]*)/g;
    var m;

    while (m = regex.exec(queryString)) {
        params[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }

    return {
        utm_source: params.utm_source || '',
        utm_medium: params.utm_medium || '',
        utm_campaign: params.utm_campaign || '',
        utm_term: params.utm_term || '',
        utm_content: params.utm_content || ''
    };
}

function storeUTMParameters() {
    var utmParams = getUTMParameters();
    for (var key in utmParams) {
        if (utmParams.hasOwnProperty(key) && utmParams[key]) {
            sessionStorage.setItem(key, utmParams[key]);
        }
    }
}

storeUTMParameters();